export const devConfig = {
  apiKey: "AIzaSyDTqyqzdSPP2W19O9YKP_5e2rQWN5-YPhE",
  authDomain: "staging-bordex-tools.firebaseapp.com",
  projectId: "staging-bordex-tools",
  storageBucket: "staging-bordex-tools.appspot.com",
  messagingSenderId: "145367885538",
  appId: "1:145367885538:web:4e4714f771984c3a3420bb",
  measurementId: "G-TT80JSGBFR",
};

export const stagingConfig = {
  apiKey: "AIzaSyDTqyqzdSPP2W19O9YKP_5e2rQWN5-YPhE",
  authDomain: "staging-bordex-tools.firebaseapp.com",
  projectId: "staging-bordex-tools",
  storageBucket: "staging-bordex-tools.appspot.com",
  messagingSenderId: "145367885538",
  appId: "1:145367885538:web:4e4714f771984c3a3420bb",
  measurementId: "G-TT80JSGBFR",
};

export const productionConfig = {
  apiKey: "AIzaSyAEkT863tLVMSW5mP-xdShIBx7dQrb8rB4",
  authDomain: "bordex-tools.firebaseapp.com",
  projectId: "bordex-tools",
  storageBucket: "bordex-tools.appspot.com",
  messagingSenderId: "655268456427",
  appId: "1:655268456427:web:0ace6bbd904957724edbae",
  measurementId: "G-3RPBVV9HYQ",
};
